var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-popovers",class:_vm.classes},[_c('div',{staticClass:"view-popovers-content",style:(_vm.positionStyleBinding)},[_c('div',{staticClass:"view-popovers-content-relative"},[_c('fade',[_c(_vm.component,{key:_vm.key,tag:"component"})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"view-popovers-overlay",on:{"click":_vm.onOverlayClick}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52573442","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Popovers.vue
// module id = 314
// module chunks = 0